import { DashboardIFrame } from "components/organisms/DashboardIFrame";

const OneListView = () => {
  return <DashboardIFrame page="listview" />;
};

export { OneListView };
